import React from 'react';
import HorizontalScrollList from '../../../../components/HorizontalScrollList';
import VerticalScrollList from '../../../../components/VerticalScrollList';

import Classes from './SearchPreviews.module.scss';
import SearchPreviewBase from './SearchPreviewBase';
import { TPreviewBlock, TSection } from '../../../../types/TConfigurablePage';

type TProps = {
  previewBlocks: TPreviewBlock[];
  visualization?: TSection['content']['visualization'];
};

const SearchPreviews = ({ previewBlocks, visualization = 'carousel' }: TProps) => {
  const ScrollList = visualization === 'grid' ? VerticalScrollList : HorizontalScrollList;

  return (
    <ScrollList.List>
      {previewBlocks.map((previewBlock, i) => (
        <ScrollList.ListItem
          className={Classes.searchPreviewWrapper}
          key={`search-preview-wrapper-${i}-${JSON.stringify(previewBlock.searchRequest)}`}
        >
          <SearchPreviewBase
            searchRequest={previewBlock.searchRequest}
            title={previewBlock.body?.title}
            lrpUrl={previewBlock.action?.link}
            ctaText={previewBlock.action?.label}
          />
        </ScrollList.ListItem>
      ))}
    </ScrollList.List>
  );
};

export default SearchPreviews;
